'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "hasScrolling", "headerComponent", "mainBackgroundColor", "mainSectionFlush", "mainSectionStyle", "Overhang", "scrollDirection", "scrollElementRef", "sidebarBackgroundColor", "sidebarComponent", "sidebarScrollElementRef", "tabs", "title", "use"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import classNames from 'classnames';
import styled from 'styled-components';
import { CARD_BACKGROUND } from './PageConstants';
import UIAbstractPageTemplate from './UIAbstractPageTemplate';
import UIMain from '../layout/UIMain';
import UIScrollingColumn from '../layout/UIScrollingColumn';
import * as CustomRenderer from '../utils/propTypes/customRenderer';
import refObject from '../utils/propTypes/refObject';
import { LAYOUT_EDITOR_PADDING } from 'HubStyleTokens/sizes';
import ShareScrollElement from '../decorators/ShareScrollElement';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MainInnerWrapper = styled.div.withConfig({
  displayName: "UIEditorPage__MainInnerWrapper",
  componentId: "sc-1usywlb-0"
})(["height:100%;padding:", ";"], props => !props.mainSectionFlush && props.hasScrolling && LAYOUT_EDITOR_PADDING);
function renderEditorSidebar(sidebarComponent, sidebarBackgroundColor, sidebarScrollElementRef, hasScrolling) {
  if (!sidebarComponent) return null;
  const RenderedSidebar = hasScrolling ? UIScrollingColumn : 'div';
  const scrollableProps = hasScrolling ? {
    scrollElementRef: sidebarScrollElementRef
  } : null;
  return /*#__PURE__*/_jsx(RenderedSidebar, Object.assign({}, scrollableProps, {
    className: "private-editor__sidebar",
    style: {
      backgroundColor: sidebarBackgroundColor
    },
    children: CustomRenderer.render(sidebarComponent)
  }));
}
class UIEditorPage extends Component {
  constructor(...args) {
    super(...args);
    this.MainSection = props => {
      const {
        mainSectionFlush,
        hasScrolling,
        Overhang,
        scrollDirection,
        scrollElementRef,
        sidebarBackgroundColor,
        sidebarScrollElementRef
      } = this.props;
      const {
        children,
        mainSectionBackgroundColor,
        mainSectionStyle,
        sidebarComponent
      } = props;
      const RenderedMain = hasScrolling ? UIScrollingColumn : UIMain;
      const computedFlush = hasScrolling ? true : mainSectionFlush;
      const scrollableProps = hasScrolling ? {
        Overhang,
        role: 'main',
        scrollDirection,
        scrollElementRef
      } : null;
      return /*#__PURE__*/_jsxs("div", {
        className: "private-editor__inner",
        children: [renderEditorSidebar(sidebarComponent, sidebarBackgroundColor, sidebarScrollElementRef, hasScrolling), /*#__PURE__*/_jsx("div", {
          className: 'private-editor__canvas' + (computedFlush ? " private-editor__canvas--flush" : ""),
          style: Object.assign({}, {
            backgroundColor: mainSectionBackgroundColor
          }, mainSectionStyle),
          children: /*#__PURE__*/_jsx(RenderedMain, Object.assign({
            className: "private-editor__main",
            flush: true
          }, scrollableProps, {
            children: /*#__PURE__*/_jsx(MainInnerWrapper, {
              hasScrolling: hasScrolling,
              mainSectionFlush: mainSectionFlush,
              children: children
            })
          }))
        })]
      });
    };
  }
  render() {
    const _this$props = this.props,
      {
        children,
        className,
        headerComponent,
        mainBackgroundColor,
        mainSectionStyle,
        sidebarComponent,
        tabs,
        title,
        use
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const mainPanelBackgroundColor = use === 'dark' ? CARD_BACKGROUND : mainBackgroundColor;
    return /*#__PURE__*/_jsx(UIAbstractPageTemplate, Object.assign({}, rest, {
      bodyClassName: "space-sword--editor",
      className: classNames('private-editor', className),
      contentAreaFlush: true,
      headerComponent: headerComponent,
      horizontalDivider: true,
      MainSection: this.MainSection,
      mainSectionBackgroundColor: mainPanelBackgroundColor,
      mainSectionStyle: mainSectionStyle,
      pageLayout: "full-width",
      sidebarComponent: sidebarComponent,
      tabs: tabs,
      title: title,
      children: children
    }));
  }
}
UIEditorPage.displayName = 'UIEditorPage';
UIEditorPage.defaultProps = {
  hasScrolling: true,
  mainSectionFlush: false,
  sidebarBackgroundColor: CARD_BACKGROUND,
  scrollDirection: UIScrollingColumn.defaultProps.scrollDirection
};
UIEditorPage.propTypes = {
  children: PropTypes.node,
  hasScrolling: PropTypes.bool.isRequired,
  headerComponent: CustomRenderer.propType,
  mainBackgroundColor: PropTypes.string,
  mainSectionFlush: PropTypes.bool,
  mainSectionStyle: PropTypes.object,
  Overhang: UIScrollingColumn.propTypes.Overhang,
  scrollDirection: UIScrollingColumn.propTypes.scrollDirection,
  scrollElementRef: refObject.isRequired,
  sidebarScrollElementRef: refObject,
  sidebarBackgroundColor: PropTypes.string,
  sidebarComponent: CustomRenderer.propType,
  tabs: PropTypes.node,
  title: PropTypes.node,
  use: PropTypes.oneOf(['default', 'dark'])
};
export default ShareScrollElement(UIEditorPage);